import { DateCalendar } from '@one-thd/sui-date-pickers';
import {
  Tile,
  TileContent,
  TileGroup,
  TileText,
  Typography,
} from '@one-thd/sui-atomic-components';
import React, { useEffect } from 'react';
import { useReturnStore } from '@src/stores/returnStore';
import {
  setSelectedPickupDate,
  useSummaryStore,
} from '@src/stores/summaryStore';
import {
  findSlotDateByCalendarDay,
  getDates,
  MORE_DATES_VALUE,
  REQUEST_DIFFERENT_DATE_VALUE,
} from '@src/utils/calendar';

export const LORPPickupDatePicker = () => {
  const pickupDates = useReturnStore((state) => state.pickupDates);
  const selectedPickupDate = useSummaryStore(
    (state) => state.selectedPickupDate,
  );
  const showCalendar = useReturnStore((state) => state.showCalendar);

  const { minDate, maxDate, unavailableDates } = React.useMemo(
    () => getDates(pickupDates),
    [pickupDates],
  );

  useEffect(() => {
    if (selectedPickupDate === MORE_DATES_VALUE && pickupDates?.[0]?.date) {
      setSelectedPickupDate(pickupDates?.[0].date);
    }
  }, [selectedPickupDate, pickupDates]);

  const handleRequestDifferentDate = () => {
    setSelectedPickupDate(REQUEST_DIFFERENT_DATE_VALUE);
  };

  let dateCalendarValue: string | null = minDate.toISOString();

  if (selectedPickupDate === REQUEST_DIFFERENT_DATE_VALUE) {
    dateCalendarValue = null;
  } else if (
    showCalendar &&
    selectedPickupDate &&
    selectedPickupDate !== MORE_DATES_VALUE
  ) {
    dateCalendarValue = new Date(selectedPickupDate).toISOString();
  }

  return (
    <>
      <div className="sui-pb-4 sui-border-strong sui-border-solid sui-border-b-1 sui-border-opacity-50">
        <DateCalendar
          value={dateCalendarValue}
          minDate={minDate}
          maxDate={maxDate}
          unavailableDates={unavailableDates}
          onChange={(_event: unknown, value: Date) => {
            setSelectedPickupDate(
              findSlotDateByCalendarDay(pickupDates, value),
            );
          }}
        />
      </div>
      <div className="sui-mt-4">
        <TileGroup
          value={selectedPickupDate}
          onChange={handleRequestDifferentDate}
        >
          <Tile
            key={REQUEST_DIFFERENT_DATE_VALUE}
            value={REQUEST_DIFFERENT_DATE_VALUE}
            aria-label="request-different-date"
            grow
          >
            <TileContent orientation="vertical">
              <TileText>Request a Different Date</TileText>
            </TileContent>
          </Tile>
        </TileGroup>
      </div>
      <div className="sui-mt-3">
        <Typography variant="body-sm">
          To schedule a custom date, submit this return request and our carrier
          will contact you within 1 business day.
        </Typography>
      </div>
    </>
  );
};
